import { apiEnvUrl, switchENV } from '../components/shared/Links';

const sessionAffinity = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/session`;

const getSSOAPI = `${switchENV(
    apiEnvUrl
    )}/aps-services/service/client/v1/sign-on/me`;

const getScoreAPI = `${switchENV(
    apiEnvUrl
)}/aps-services/service/client/v1/score/me`;

export default {
    sessionAffinity,
    getSSOAPI,
    getScoreAPI
};
